// @flow

import styled, { css } from 'styled-components';
import { nearLime, neonRed } from './colors';

const Icon = styled.i`
  line-height: 1;

  &::before, &::after {
    font-family: Icon Font !important;
    line-height: 1;
    speak: none;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
`;

export const IconOnline = styled(Icon)`
  &::before {
    content: '\ ';
    display: inline-block;
    vertical-align: middle;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: ${nearLime};
    position: relative;
    top: -2px;
    margin-right: 8px;
  }

  ${({ offline }) => offline && css`
    &:before {
      background-color: ${neonRed};
    }
  `}
`;

export const IconNoEdit = styled(Icon)`
  &::before {
    content: "\\e9a2";
    color: rgb(48, 52, 70);
    opacity: 0.1;
  }

  &::after {
    content: "\\e9a3";
    margin-left: -1em;
    color: rgb(151, 153, 162);
  }
`;

export const IconEdit = styled(Icon)`
  &::before {
    content: "\\e9a0";
    color: rgb(48, 52, 70);
    opacity: 0.1;
  }

  &::after {
    content: "\\e9a1";
    margin-left: -1em;
    color: rgb(151, 153, 162);
  }
`;

export const IconEye                      = styled(Icon)`&::before { content: '\\e9a4'; }`;
export const IconEyeSlash                 = styled(Icon)`&::before { content: '\\e9a5'; }`;
export const IconAddVideo                 = styled(Icon)`&::before { content: '\\e916'; }`;
export const IconAlert                    = styled(Icon)`&::before { content: '\\e90a'; }`;
export const IconAngleBottom              = styled(Icon)`&::before { content: '\\e924'; }`;
export const IconAngleRight               = styled(Icon)`&::before { content: '\\e923'; }`;
export const IconArrowRight               = styled(Icon)`&::before { content: '\\e914'; }`;
export const IconArrowRightBig            = styled(Icon)`&::before { content: '\\e90f'; }`;
export const IconAttention                = styled(Icon)`&::before { content: '\\e959'; }`;
export const IconBaby                     = styled(Icon)`&::before { content: '\\e917'; }`;
export const IconBack                     = styled(Icon)`&::before { content: '\\e94c'; }`;
export const IconBenefitOwl               = styled(Icon)`&::before { content: '\\e95c'; }`;
export const IconBenefits                 = styled(Icon)`&::before { content: '\\e94e'; }`;
export const IconBenefitTeam              = styled(Icon)`&::before { content: '\\e95b'; }`;
export const IconBonus                    = styled(Icon)`&::before { content: '\\e95d'; }`;
export const IconBook                     = styled(Icon)`&::before { content: '\\e922'; }`;
export const IconBookmark                 = styled(Icon)`&::before { content: '\\e90c'; }`;
export const IconBookmarked               = styled(Icon)`&::before { content: '\\e90d'; }`;
export const IconBriefcase                = styled(Icon)`&::before { content: '\\e939'; }`;
export const IconBulletList               = styled(Icon)`&::before { content: '\\e94f'; }`;
export const IconBus                      = styled(Icon)`&::before { content: '\\e950'; }`;
export const IconCafetaria                = styled(Icon)`&::before { content: '\\e95e'; }`;
export const IconCalendar                 = styled(Icon)`&::before { content: '\\e900'; }`;
export const IconCalendarO                = styled(Icon)`&::before { content: '\\e95f'; }`;
export const IconCar                      = styled(Icon)`&::before { content: '\\e951'; }`;
export const IconCarO                     = styled(Icon)`&::before { content: '\\e960'; }`;
export const IconCategory                 = styled(Icon)`&::before { content: '\\e903'; }`;
export const IconCategoryO                = styled(Icon)`&::before { content: '\\e961'; }`;
export const IconCell                     = styled(Icon)`&::before { content: '\\e962'; }`;
export const IconCheckboxEmpty            = styled(Icon)`&::before { content: '\\e963'; }`;
export const IconCheckboxFilled           = styled(Icon)`&::before { content: '\\e964'; }`;
export const IconCheckboxUnselect         = styled(Icon)`&::before { content: '\\e965'; }`;
export const IconCheckmark                = styled(Icon)`&::before { content: '\\e90e'; }`;
export const IconChild                    = styled(Icon)`&::before { content: '\\e966'; }`;
export const IconClock                    = styled(Icon)`&::before { content: '\\e911'; }`;
export const IconClockO                   = styled(Icon)`&::before { content: '\\e90b'; }`;
export const IconClose                    = styled(Icon)`&::before { content: '\\e919'; }`;
export const IconCloseO                   = styled(Icon)`&::before { content: '\\e928'; }`;
export const IconCoach                    = styled(Icon)`&::before { content: '\\e967'; }`;
export const IconCompany                  = styled(Icon)`&::before { content: '\\e904'; }`;
export const IconCompanyFavorite          = styled(Icon)`&::before { content: '\\e929'; }`;
export const IconCrown                    = styled(Icon)`&::before { content: '\\e94d'; }`;
export const IconDelete                   = styled(Icon)`&::before { content: '\\e968'; }`;
export const IconDepartment               = styled(Icon)`&::before { content: '\\e969'; }`;
export const IconDesiredOffice            = styled(Icon)`&::before { content: '\\e96a'; }`;
export const IconDiscount                 = styled(Icon)`&::before { content: '\\e96b'; }`;
export const IconDiscover                 = styled(Icon)`&::before { content: '\\e91b'; }`;
export const IconDoctor                   = styled(Icon)`&::before { content: '\\e96c'; }`;
export const IconDownload                 = styled(Icon)`&::before { content: '\\e901'; }`;
export const IconDrag                     = styled(Icon)`&::before { content: '\\e96d'; }`;
export const IconDrink                    = styled(Icon)`&::before { content: '\\e96e'; }`;
export const IconEasyAccess               = styled(Icon)`&::before { content: '\\e96f'; }`;
export const IconEmail                    = styled(Icon)`&::before { content: '\\e92a'; }`;
export const IconEmailSent                = styled(Icon)`&::before { content: '\\e93a'; }`;
export const IconEnvelopeOpen             = styled(Icon)`&::before { content: '\\e93b'; }`;
export const IconEnvelopeUp               = styled(Icon)`&::before { content: '\\e942'; }`;
export const IconEquipment                = styled(Icon)`&::before { content: '\\e970'; }`;
export const IconExternalLink             = styled(Icon)`&::before { content: '\\e909'; }`;
export const IconFacebook                 = styled(Icon)`&::before { content: '\\e92b'; }`;
export const IconInstagram                = styled(Icon)`&::before { content: '\\e9a7'; }`;
export const IconTiktok                   = styled(Icon)`&::before { content: '\\e9a8'; }`;
export const IconFile                     = styled(Icon)`&::before { content: '\\e92d'; }`;
export const IconFilter                   = styled(Icon)`&::before { content: '\\e920'; }`;
export const IconFlatHierarchy            = styled(Icon)`&::before { content: '\\e971'; }`;
export const IconFlexible                 = styled(Icon)`&::before { content: '\\e972'; }`;
export const IconFood                     = styled(Icon)`&::before { content: '\\e973'; }`;
export const IconFootball                 = styled(Icon)`&::before { content: '\\e916'; }`;
export const IconFruit                    = styled(Icon)`&::before { content: '\\e974'; }`;
export const IconGoogle                   = styled(Icon)`&::before { content: '\\e92c'; }`;
export const IconGraduationHat            = styled(Icon)`&::before { content: '\\e908'; }`;
export const IconHamburger                = styled(Icon)`&::before { content: '\\e927'; }`;
export const IconHealth                   = styled(Icon)`&::before { content: '\\e975'; }`;
export const IconHelp                     = styled(Icon)`&::before { content: '\\e937'; }`;
export const IconHome                     = styled(Icon)`&::before { content: '\\e952'; }`;
export const IconHomeOffice               = styled(Icon)`&::before { content: '\\e976'; }`;
export const IconHouse                    = styled(Icon)`&::before { content: '\\e906'; }`;
export const IconInsertGallery            = styled(Icon)`&::before { content: '\\e953'; }`;
export const IconInsertPhoto              = styled(Icon)`&::before { content: '\\e954'; }`;
export const IconJob                      = styled(Icon)`&::before { content: '\\e905'; }`;
export const IconJobFavorite              = styled(Icon)`&::before { content: '\\e930'; }`;
export const IconJobs                     = styled(Icon)`&::before { content: '\\e977'; }`;
export const IconLanguage                 = styled(Icon)`&::before { content: '\\e978'; }`;
export const IconLayout                   = styled(Icon)`&::before { content: '\\e921'; }`;
export const IconLink                     = styled(Icon)`&::before { content: '\\e93c'; }`;
export const IconLocation                 = styled(Icon)`&::before { content: '\\e925'; }`;
export const IconLocationSmall            = styled(Icon)`&::before { content: '\\e979'; }`;
export const IconLock                     = styled(Icon)`&::before { content: '\\e93d'; }`;
export const IconLogout                   = styled(Icon)`&::before { content: '\\e931'; }`;
export const IconLogoutO                  = styled(Icon)`&::before { content: '\\e93e'; }`;
export const IconMaternity                = styled(Icon)`&::before { content: '\\e97a'; }`;
export const IconMedia                    = styled(Icon)`&::before { content: '\\e97b'; }`;
export const IconMentor                   = styled(Icon)`&::before { content: '\\e97c'; }`;
export const IconMessage                  = styled(Icon)`&::before { content: '\\e91e'; }`;
export const IconMessenger                = styled(Icon)`&::before { content: '\\e93f'; }`;
export const IconMinusBullet              = styled(Icon)`&::before { content: '\\e92e'; }`;
export const IconMobile                   = styled(Icon)`&::before { content: '\\e940'; }`;
export const IconMore                     = styled(Icon)`&::before { content: '\\e97d'; }`;
export const IconMouse                    = styled(Icon)`&::before { content: '\\e941'; }`;
export const IconMultinational            = styled(Icon)`&::before { content: '\\e97e'; }`;
export const IconNext                     = styled(Icon)`&::before { content: '\\e97f'; }`;
export const IconNumericList              = styled(Icon)`&::before { content: '\\e955'; }`;
export const IconPage                     = styled(Icon)`&::before { content: '\\e938'; }`;
export const IconParental                 = styled(Icon)`&::before { content: '\\e980'; }`;
export const IconParking                  = styled(Icon)`&::before { content: '\\e981'; }`;
export const IconParkingSpot              = styled(Icon)`&::before { content: '\\e915'; }`;
export const IconPaternity                = styled(Icon)`&::before { content: '\\e982'; }`;
export const IconPet                      = styled(Icon)`&::before { content: '\\e983'; }`;
export const IconPhone                    = styled(Icon)`&::before { content: '\\e932'; }`;
export const IconPiggyBank                = styled(Icon)`&::before { content: '\\e910'; }`;
export const IconPlaceholder              = styled(Icon)`&::before { content: '\\e984'; }`;
export const IconPlus                     = styled(Icon)`&::before { content: '\\e902'; }`;
export const IconPlusBullet               = styled(Icon)`&::before { content: '\\e92f'; }`;
export const IconPlusBulletO              = styled(Icon)`&::before { content: '\\e985'; }`;
export const IconPopupClose               = styled(Icon)`&::before { content: '\\e986'; }`;
export const IconPrevious                 = styled(Icon)`&::before { content: '\\e987'; }`;
export const IconPrint                    = styled(Icon)`&::before { content: '\\e933'; }`;
export const IconProdev                   = styled(Icon)`&::before { content: '\\e988'; }`;
export const IconProducts                 = styled(Icon)`&::before { content: '\\e943'; }`;
export const IconProfile                  = styled(Icon)`&::before { content: '\\e934'; }`;
export const IconRadioButton              = styled(Icon)`&::before { content: '\\e989'; }`;
export const IconRedo                     = styled(Icon)`&::before { content: '\\e91d'; }`;
export const IconRefresh                  = styled(Icon)`&::before { content: '\\e944'; }`;
export const IconRelocation               = styled(Icon)`&::before { content: '\\e98a'; }`;
export const IconRemote                   = styled(Icon)`&::before { content: '\\e98b'; }`;
export const IconReset                    = styled(Icon)`&::before { content: '\\e945'; }`;
export const IconRetirement               = styled(Icon)`&::before { content: '\\e98c'; }`;
export const IconSabbatical               = styled(Icon)`&::before { content: '\\e98d'; }`;
export const IconSalary                   = styled(Icon)`&::before { content: '\\e98e'; }`;
export const IconSave                     = styled(Icon)`&::before { content: '\\e935'; }`;
export const IconSavedSearch              = styled(Icon)`&::before { content: '\\e91c'; }`;
export const IconSaveSearch               = styled(Icon)`&::before { content: '\\e918'; }`;
export const IconScreen                   = styled(Icon)`&::before { content: '\\e946'; }`;
export const IconSearch                   = styled(Icon)`&::before { content: '\\e91f'; }`;
export const IconSearchO                  = styled(Icon)`&::before { content: '\\e98f'; }`;
export const IconSearchResults            = styled(Icon)`&::before { content: '\\e91a'; }`;
export const IconSelected                 = styled(Icon)`&::before { content: '\\e990'; }`;
export const IconSetting                  = styled(Icon)`&::before { content: '\\e991'; }`;
export const IconSettingCharacteristic    = styled(Icon)`&::before { content: '\\e992'; }`;
export const IconSettingGeneral           = styled(Icon)`&::before { content: '\\e993'; }`;
export const IconSettings                 = styled(Icon)`&::before { content: '\\e912'; }`;
export const IconShare                    = styled(Icon)`&::before { content: '\\e907'; }`;
export const IconSnacks                   = styled(Icon)`&::before { content: '\\e994'; }`;
export const IconSocial                   = styled(Icon)`&::before { content: '\\e947'; }`;
export const IconSocialUp                 = styled(Icon)`&::before { content: '\\e948'; }`;
export const IconSport                    = styled(Icon)`&::before { content: '\\e95a'; }`;
export const IconStar                     = styled(Icon)`&::before { content: '\\e926'; }`;
export const IconStarBlank                = styled(Icon)`&::before { content: '\\e936'; }`;
export const IconStock                    = styled(Icon)`&::before { content: '\\e995'; }`;
export const IconStudy                    = styled(Icon)`&::before { content: '\\e996'; }`;
export const IconStudyOwl                 = styled(Icon)`&::before { content: '\\e913'; }`;
export const IconTarget                   = styled(Icon)`&::before { content: '\\e949'; }`;
export const IconText                     = styled(Icon)`&::before { content: '\\e956'; }`;
export const IconTextimage                = styled(Icon)`&::before { content: '\\e957'; }`;
export const IconTextO                    = styled(Icon)`&::before { content: '\\e997'; }`;
export const IconTicket                   = styled(Icon)`&::before { content: '\\e998'; }`;
export const IconTime                     = styled(Icon)`&::before { content: '\\e958'; }`;
export const IconTimeO                    = styled(Icon)`&::before { content: '\\e999'; }`;
export const IconTravel                   = styled(Icon)`&::before { content: '\\e99a'; }`;
export const IconVacation                 = styled(Icon)`&::before { content: '\\e99b'; }`;
export const IconX                        = styled(Icon)`&::before { content: '\\e99c'; }`;
export const IconYoutube                  = styled(Icon)`&::before { content: '\\e99d'; }`;
export const IconLinkedIn                 = styled(Icon)`&::before { content: '\\e9a6'; }`;
export const IconZoomIn                   = styled(Icon)`&::before { content: '\\e94a'; }`;
export const IconZoomOut                  = styled(Icon)`&::before { content: '\\e94b'; }`;
